var map = {
	"./de/kv.jpg": "fC1T",
	"./en/kv.jpg": "JygJ",
	"./es/kv.jpg": "NPAn",
	"./fr/kv.jpg": "rVUK",
	"./ja/kv.jpg": "Osl2",
	"./ko/kv.jpg": "9EYF",
	"./pt/kv.jpg": "BU8Z",
	"./ru/kv.jpg": "eO5P",
	"./th/kv.jpg": "y88Q",
	"./zh-Hant/kv.jpg": "YftZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1gUY";